import React from 'react'

import { CguWrapper, CenterWrapper } from './cgu.styles'

const Cgu: React.FC = () => {
  return (
    <CguWrapper>
      <CenterWrapper>
        <h1>URBASOLAR</h1>
        <p>
          75 Allée Wilhelm Roentgen, 34000 Montpellier 04 67 64 46 44 <br /> <br />
          Contact : hello@urbasolar.com
        </p>
        <h2>MENTIONS LEGALES</h2>
        <p>Nom de l&apos;Application : Espace Client Urbasolar</p>
        <p>
          Société : URBASOLAR Société par actions simplifiée au capital de 2 068 416€ Dont le Siège
          social est situé 75, allée Wilhelm Roentgen - CS 40935 - 34961 Montpellier CEDEX 2 -
          FRANCE Immatriculée au RCS de Montpellier sous le numéro 492 381 157, représentée par
          Monsieur Arnaud Mine, en sa qualité de Président.
        </p>
        <p>Numéro de Téléphone : 0467644644</p>
        <p>
          Les mentions légales pouvant être modifiées à tout moment et sans préavis, nous vous
          engageons à les consulter régulièrement.
        </p>
        <p>Dernière modification des conditions générales d’utilisation : 26/11/2020</p>
        <h2>ARTICLE 1 : DEFINITIONS</h2>
        <p>
          APPLICATION : désigne l&apos;application Espace Client Urbasolar mise en place par la
          société URBASOLAR pour communiquer, à tout moment, aux utilisateurs connectés sur
          l&apos;Application sur les données de production et le chiffre d&apos;affaires de la
          centrale photovoltaïque qui les concerne. UTILISATEUR : désigne toute personne se
          connectant à l&apos;Application grâce au code confidentiel qui lui aura été attribué
          précédemment par la société URBASOLAR. EDITEUR : désigne la société URBASOLAR dont les
          mentions légales sont disponibles sur l&apos;Application
        </p>
        <h2>ARTICLE 2 : OBJET</h2>
        <p>
          Les présentes Conditions Générales d&apos;Utilisation (ci-après désignées &quot; CGU
          &quot;) sont en langue française et ont vocation à s&apos;appliquer de façon exclusive
          entre la société URBASOLAR et tout Utilisateur souhaitant accéder à l&apos;Application.
        </p>
        <h2>ARTICLE 3 : ACCES A L&apos;APPLICATION</h2>
        <p>
          L&apos;accès à l&apos;Application et son utilisation sont uniquement réservés aux
          personnes en relation avec l&apos;Editeur et ayant un intérêt à consulter les données
          présentes sur l&apos;Application. L&apos;accès à l&apos;Application est strictement
          personnel. L&apos;Editeur enverra par courriel électronique un code personnel d&apos;accès
          à l&apos;Application à chaque Utilisateur. Ce code ne pourra être modifié par
          l&apos;Utilisateur. Il est précisé que ce code est strictement confidentiel et que
          l&apos;Utilisateur s&apos;engage à ne pas le communiquer à d&apos;autres personnes. En cas
          de doute sur l&apos;utilisateur de l&apos;Application, l&apos;Editeur se réserve le droit
          de demander toute justification utile pour accéder à l&apos;Application. Tout Utilisateur
          de l&apos;Application reconnait avoir pris connaissance des présentes CGU et
          s&apos;engage, sans restriction ni réserve, à s&apos;y conformer.
        </p>
        <h2>ARTICLE 4 : CONTENU DE L&apos;APPLICATION – PROPRIETE INTELLECTUELLE</h2>
        <p>
          Les valeurs, chiffres et les données diffusés par URBASOLAR par le biais de
          l&apos;Application sont communiqués par l&apos;Editeur à titre indicatif et ont une valeur
          purement informative et en aucun cas contractuelle. Les informations communiquées à
          l&apos;Utilisateur de l&apos;Application ne peuvent donc en aucun cas engager la
          responsabilité de l&apos;Editeur et demeurent sa propriété. Par ailleurs, tous les
          éléments comme notamment les marques, les logos, les photographies, les textes contenus
          dans l&apos;Application, ainsi que tous les éléments créés pour l’Application et sa
          structure générale, sont soit la propriété de l&apos;Editeur, soit font l’objet de droits
          d’utilisation, de reproduction et de représentation consentis au profit de ce dernier. Ces
          informations, documents ou éléments et sont protégés par lessoumis aux lois protégeant le
          droit d’auteur dès lors qu’elles sont mises à la disposition du public sur cette
          Application. Aucune licence, ni aucuns droits autres que ceux de télécharger et consulter
          l’Application, ne sont conférés à quiconque au regard des droits de propriété
          intellectuelle. Toute reproduction, représentation, utilisation ou adaptation, sous
          quelque forme que ce soit, de tout ou partie de ces éléments, à d’autres fins, sans
          l&apos;accord préalable et écrit de l&apos;Editeur, sont strictement interdites. Toute
          exploitation non autorisée de ces éléments est constitutive d&apos;actes de contrefaçon de
          droit d&apos;auteur et/ou droit des signes distinctifs et engage la responsabilité pénale
          et civile de l&apos;Utilisateur qui y contreviendrait sur le fondement de la contrefaçon
          de droits d&apos;auteur et/ou droit des signes distinctifs. Le fait pour l&apos;Editeur de
          ne pas engager de procédure dès la prise de connaissance de ces utilisations non
          autorisées ne vaut pas acceptation desdites utilisations et renonciation aux poursuites.
        </p>
        <h2>ARTICLE 5 : GESTION DE L&apos;APPLICATION</h2>
        <p>
          L&apos;Editeur fait ses meilleurs efforts afin de rendre l&apos;Application disponible 24
          heures sur 24 et 7 jours sur 7 aux Utilisateurs. Cependant, pour la bonne gestion de
          l&apos;Application, l&apos;Editeur pourra, à tout moment, suspendre, interrompre ou
          limiter l&apos;accès à tout ou partie de l&apos;Application. Il pourra également, à tout
          moment, supprimer toute information pouvant perturber le fonctionnement de
          l&apos;Application ou entrant en contravention avec les lois nationales ou
          internationales. L&apos;Editeur s&apos;autorise à suspendre le fonctionnement de
          l&apos;Application afin de procéder à des mises à jour.
        </p>
        <h2>ARTICLE 6 : RESPONSABILITES </h2>
        <p>
          Chaque Utilisateur de l’Application déclare se conformer aux présentes Conditions
          Générales d’Utilisation ainsi qu’aux lois en vigueur. <br />
          La responsabilité de l&apos;Editeur, directe ou indirecte, ne peut être engagée en cas de
          défaillance, panne, difficulté ou interruption de fonctionnement, empêchant l&apos;accès à
          l&apos;Application ou à une de ses fonctionnalités. <br />
          Les informations disponibles sur cette Application vous sont proposées en toute bonne foi.{' '}
          <br />
          L’Editeur n’est ni représentant ni garant du caractère exhaustif et de l’exactitude de ces
          informations. <br />
          En aucun cas, l’Editeur s’engage à mettre à jour ou à corriger les informations qui seront
          diffusées sur cette Application. De même, l’Editeur se réserve le droit de modifier ou de
          corriger le contenu de l’Application à tout moment et sans préavis. Le matériel de
          connexion à l&apos;Application que vous utilisez et sous votre entière responsabilité.
          Vous devez prendre toutes les mesures appropriées pour protéger votre matériel et vos
          propres données. L&apos;Editeur n&apos;est pas responsable des dommages causés à vous-
          même, à des tiers et/ou votre équipement du fait de votre connexion ou de votre
          utilisation du site et vous renoncez à toute action contre lui de ce fait.
        </p>
        <h2>ARTICLE 7: COLLECTE DE DONNEES</h2>
        <p>
          Conformément à la règlementation en vigueur, chaque Utilisateur dispose à tout moment
          d&apos;un droit d&apos;accès aux informations le concernant, d’un droit de rectification
          si elles sont inexactes, d’un droit d’opposition à leur transmission à des tiers et à leur
          utilisation à des fins de prospection commerciale, et plus généralement d’un droit
          d’opposition à toutes formes de traitement. <br />
          Pour exercer ces droits, l’Utilisateur doit contacter l’Editeur par mail ou pour courrier
          en utilisant les coordonnées communiquées en introduction des présentes. <br />
          L’Utilisateur peut également demander la fermeture de son compte en utilisant les mêmes
          moyens.
        </p>
        <h2>ARTICLE 8 : LOI APPLICABLE</h2>
        <p>
          Les présentes mentions légales de l&apos;Application sont régies par la loi française. En
          cas de litige ou de désaccord entre les l&apos;Editeur et un Utilisateur, lié au présent
          contrat, tant en ce qui concerne son interprétation que son exécution, l&apos;une
          d&apos;entre elles délivrera à l&apos;autre une demande écrite tendant à la tenue
          d&apos;une réunion au cours de laquelle elles tenteront de parvenir à un règlement amiable
          dans un délai raisonnable. Elles conviennent de négocier et de rechercher une solution
          amiable de bonne foi aux fins de règlement dudit litige pendant une période de soixante
          (60) jours calendaires à compter de la réception de cet avis. Si le litige n&apos;a pas
          été réglé de manière amiable dans ce délai, chacune d&apos;entre elles pourra engager la
          procédure judiciaire qu&apos;elle considérera comme appropriée devant les tribunaux
          compétents de Montpellier, sous réserve d&apos;une attribution de compétence spécifique
          découlant d&apos;un texte de loi ou réglementaire particulier.
        </p>
        <h2>ARTICLE 9 : MODIFICATION DES CGU</h2>
        <p>
          L&apos;Editeur se réserve le droit de modifier librement les CGU. Toute nouvelle version
          de celles-ci sera signalée préalablement sur la première page de la rubrique Informations
          Légales. Par conséquent, nous vous invitions à vous y référer lors de chaque visite sur
          l&apos;Application afin de prendre connaissance de leur dernière version disponible en
          permanence sur l&apos;Application. Vous êtes libre ensuite de ne pas accéder à
          l&apos;Application si les conditions ne vous conviennent pas. Les Utilisateurs qui ne
          souhaitent pas que les relations contractuelles soient régies par la nouvelle version des
          CGU, devront le notifier et, à compter de la date à partir de laquelle la nouvelle version
          prendra effet, ils devront cesser d&apos;utiliser l&apos;Application. Toute modification
          prendra effet immédiatement et ne s&apos;appliquera qu&apos;aux Utilisateurs utilisant
          l&apos;Application postérieurement à ladite modification.
        </p>
        <h2>ARTICLE 10 : CONTACT</h2>
        <p>
          Pour toute question, informations sur les données présentées sur l&apos;Application ou
          concernant l&apos;Application elle-même, vous pouvez laisser un message à l&apos;adresse
          suivante : hello@urbasolar.com
        </p>
      </CenterWrapper>
    </CguWrapper>
  )
}

export default Cgu
